module.exports = {
    language: {
        name: '中文'
    },
    user: {
        name: 'Shanghai Renwei Electronic Technology Co., Ltd',
        nametext: 'production base',
        home: 'HOME',
        company: 'Who we are?',
        team: 'Executive Team',
        culture: 'Culture/Careers',
        honor: 'Honor',
        exhibition: 'Exhibition',
        partner: 'Partner',
        describe: 'Rewin is a group company who focusing on the intelligent manufacturing. Rewin has advanced SMT equipments which are capable of 0201 and BGA Pitch 0.35mm fine-pitch components,  and also capable of 20 levels of PCBA manufacturing. ',
        describe2: 'The company was found in Apr-2009. The main manufacturing OEM/ODM products including Industry Control, Auto electronics, Medical electronics, and IoT products. Company located in Songjiang Development Zone, with 4000 sq.m factury space.',
        describetext: 'Company description',
        emplyee: 'Company has around 100 empoyees. The key functional persons comes from some global EMS componies including Jabil, Foxconn, Inventec and Asus. They have rich work experiences. ',
        emplyeetext: 'Emplyee',
        salesvolume: 'Annual Sales Volume',
        salesvolumetext1: '2018 Sales Volume:$4.3M',
        salesvolumetext2: '2019 Sales Volume: $5.2M',
        salesvolumetext3: '2020 Sales Volume: $6.2M',
        salesvolumetext4: '2021 Estimated sales: $7.7M',
        contact: 'contact us',
        address: 'address',
        addresstext: 'No. 8 Building, 889 Kungang Highway, Songjiang District, Shanghai ',
        Postcode: 'Postcode',
        number: 'number',
        Fax: 'Fax',
        Email: 'E-mail',
        business: 'scope of business',
        Solutions: 'Case: RF Boards，Electric servo inverter controller and LED Power supply from Pulse company',
        Products: 'Case: Cooling machine, Michi thermostatic mat and Healthy products',
        Manufacturing: 'SMT, DIP, Testing, Burn-in and High Level Assembly',
        Service: 'DFM, Failure Analysis and the related service in lab',
        Solutionstext: 'Solutions',
        Productstext: 'Products',
        Manufacturingtext: 'Manufacturing',
        servicetext: 'Service',
        news: 'news',
        storage: 'Intelligent storage',
        advantage: 'Our strengths'
    },
    storage: {
        iqc: 'IQC Dashboard',
        temperature: 'Temperature&Humidity Control Sensor',
        e_kanban: 'Material Preparation dashboard',
        intelligence_storage: 'Intelligent storage for  Electronic materials',
        workshop: 'Material Shelf',
        goods_shelves: 'WIFI intelligent Rack',
        mes: 'MES Traceability',
        pvs: 'PVS Wrong Part Error-proof'
    },
    product: {
        molding: 'Injection molding',
        purifier: 'purifier',
        purifier2: 'Voice control purifier',
        Videoconferencing: 'Videoconferencing',
        Payment: 'Payment terminal',
        refrigerator: 'Car refrigerator',
        product1: 'High speed rail seat',
        product2: 'LED automobile instrument'
    },
    news: {
        detail: 'detailed information >',
        title1: '姜堰上海商会走访副会长单位上海任威电子科技有限公司',
        content1: '6月5日，姜堰上海商会顾问戴忠茂、会长周正明、书记黄宝生等一行走访副会长单位上海任威电子科技有限公司。',
        link1: 'https://mp.weixin.qq.com/s/30PhEs4YbvvEVryJ8Eq2CQ',
        title2: '上海市江苏商会青年联合会 “9月会长办公会暨走进上海任威电子”活动举办圆满成功',
        content2: '9月24日下午，上海市江苏商会青年联合会（以下简称“青联会”）在周常凤秘书长的的带领下，副会长代表、理事代表、会员代表及苏商商学院嘉宾十几人走访了上海任威电子科技有限公司（以下简称“上海任威电子”）。上海任威电子团队热情接待了青联会一行，双方进行了深入的交流。',
        link2: 'https://mp.weixin.qq.com/s/RZqh-NP2ciL9iYcqgHOx6w',
        title3: '同光走进明星学员企业—上海任威电子科技有限公司',
        content3: '精英齐聚，匠心筑梦，10月15日（周四），受EMBA28/PE18期纪武德纪总盛情邀请，组织同学们走进任威电子，学习企业的经营之道，加强同学人脉资源整合。',
        link3: 'https://mp.weixin.qq.com/s/_VF7qp2ETo9GjwC9_tM9vQ',
        title4: '走访调研民营企业上海任威电子科技有限公司',
        content4: '为贯彻落实习近平总书记在民营企业家座谈会上的重要讲话精神，了解掌握行业民营企业发展实际情况，帮助解决企业存在的困难和问题，推动民营经济在新形势下高质量发展。2020年6月24日上午，市中小企业发展服务中心信息化推进部、市计算机协会一行深入民营企业上海任威电子科技有限公司进行实地走访调研。',
        link4: 'https://mp.weixin.qq.com/s/aZEzkuNe5F1zHCl7MNL87w'
    },
    recruit: {
        recruit: 'Talent recruitment',
        title1: 'Sales Engineer',
        recruitinfo: 'Position information',
        info1: '1，Responsible for domestic (mainly in East China) or overseas sales；',
        info2: '2，Actively develop new customers and maintain customer relationship; Complete the sales target set by the Department (resources provided by the company to customers)；',
        info3: "3，Promote the company's products, understand and tap customer needs; Communicate and coordinate with technical team to acquire and complete customer projects；",
        info4: '4，Cooperate with finance and assistant team to complete the payment collection task；',
        demand: 'Job requirements',
        info5: '1. College degree or above, major in electronic engineering, computer, marketing, etc',
        info6: '2. Basic English reading and writing skills (domestic customers can do without strict restrictions)',
        info7: '3. Engaged in related research and development, technical support, testing and other work is preferred, work experience is preferred, fresh graduates can also be considered',
        info8: '4. Excellent interpersonal communication and business negotiation skills',
        info9: '5. Like challenging work and strong team work spirit',
        info10: "6. A driver's license is preferred",
        title2: 'Project tracking Engineer',
        info11: '1, Quotation for new products according to the drawings provided by customers (the company has quotation module)',
        info12: '2, Responsible for the management and filing of all orders received from customers, and translate them into internal production orders',
        info13: '3, In the project operation, maintain positive and effective communication with customers, and timely convey customer requirements to the team; Maintain good relationship with customers',
        info14: '4, Make the delivery plan and key nodes of the project, track and supervise the work progress of the team to meet the needs of customers',
        info15: '5, For the received customer complaints, organize team to analyze the causes, formulate corrective and preventive measures and timely feedback to customers. For after-sales quality loss, statistics for subsequent analysis',
        info16: '6, Make billing plan and assist finance department in billing and collection of delivered products',
        info17: '1. College degree or above, major in electronics',
        info18: '2. More than 1 year project management experience in electronics or related manufacturing industry, ability to receive customers is preferred',
        info19: '3. Good communication ability, negotiation ability and cost control awareness',
        info20: '4. Familiar with office software',
        info21: '5. Good professional ethics, professionalism and teamwork spirit',
        treatment: 'Terms of treatment',
        condition1: '1，Basic salary + post salary + performance salary + rental subsidy + full attendance award + work annuity',
        condition2: '2，13 salary, 1-2 domestic or foreign tourism every year',
        condition3: '3，Welfare, birthday allowance, annual leave, overtime allowance and compensatory leave for each festival',
        condition4: '4，Have worked for 5 years or 10 years and have equity dividend',
        condition5: '5，The company arranges in-house and overseas training from time to time',
        condition6: '6，Project merchandiser engineer has project subsidy, sales engineer has sales commission',
        contact: 'Contact information: 18917388687 (same as wechat), contact person: Mr. Ji, contact address: No. 8 Building, 889 Kungang Highway, Songjiang District, Shanghai '
    },
    team: {
        engineering: 'ME Dpt',
        project: 'Project Dpt',
        qaqc: 'Quality Dpt',
        production: 'MFG Dpt',
        engineeringtext: 'Developing manufacturing process and related controls',
        projecttext: 'The design, production and process development  for new product. Product evaluation. And customer service.',
        qaqctext: 'Be in charge of IQC、PQC and QA to assure the good product delivered to customer.',
        productiontext: 'Based on schedule, MFG to control production output, labor arrangement and balance equipment.'
    },
    exhibition: {
        work: 'Office Environment',
        SMT1: 'SMT Production factory',
        SMT2: 'SMT Production factory'
    },
    culture: {
        title: 'What are the values that define our corporate culture',
        culture1: 'Observe discipline and law',
        culture2: 'The city keeps its promise',
        culture3: 'Customer first',
        culture4: 'work hard and perseveringly',
        culture5: 'For innovation',
        culture6: 'Facing the future',
        foo: "Our energy comes from every employee's viewpoint, ability, experience and dedication。"
    },
    market: {
        manufacturer: 'manufacturer：',
        type: 'type：',
        classify: 'classify：',
        message: "So let's delete classify",
        languageType: '2',
        search: 'search',
        placeholder: 'Please enter the product name',
        name: 'name',
        image: 'image',
        model: 'model',
        manufacturer1: 'manufacturer',
        costPrice: 'costPrice',
        specialPrice: 'specialPrice',
        sellingPrice: 'sellingPrice',
        description: 'description',
        commodity: 'commodity',
        shopping: 'add shopping',
        successfully: 'Add to cart successfully!',
        handle: 'handle',
        inquiry: 'Inquiry for goods',
        products: 'Hello, I would like to inquire about the prices of the following products',

        mailbox: 'email address：',
        phone: 'mobile phone：',
        hrefShopping: 'product model：',
        cancel: 'cancel',
        confirm: 'confirm',
        subject: 'Inquiry for chip',
        enquiry: 'enquiry',
        mailboxformat: 'The format of the mailbox number is incorrect',
        mailboxs: 'Please enter the email number',
        phoneformat: 'The format of the mobile phone number is incorrect',
        phones: 'Please enter your mobile phone number',
        send0: 'send successfully!',
        send1: 'sending failure，Please fill in the form correctly！！！',
        verification: 'verification：',
        verificationtrue: 'Please enter the correct verification code!'
    },
    honor: {
        zhengshu7: "zhengshu092602.png",
        zhengshu9: "zhengshu092603.png",
        zhengshu11: "zhengshu092606.png",
    }
}


// WEBPACK FOOTER //
// ./src/components/language/en.js